export default "\n";
//# sourceMappingURL=lighting-common.glsl.js.map